import type { Locale } from '@tuic/i18n';
import { logger } from '@tuic/logger';
import { Bookinghub, CacheTag } from '../../index';
import type { ApiStatefulResponseWithData } from '../../utils/api-result';
import { remember, serializeDataToCacheKey } from '@tuic/cache';

export const getCabinGifts = async (
  locale: Locale,
): Promise<ApiStatefulResponseWithData<Bookinghub.CabinPresentCategory[]>> => {
  let { data, error } = await Bookinghub.getCabinpresents({
    query: { locale },
  });

  if (error) {
    logger.error(`Could not fetch cabin presents, Locale: ${locale}`);
    logger.error(error);
    return { success: false };
  }

  // Note: 1.7.0 spec swapped CabinPresent response types — GET returns the array as CabinPresentSuccessResponse
  return {
    success: true,
    data: (data as unknown as Bookinghub.CabinPresentCategory[]) ?? [],
  };
};

export const getCabinGiftsCached = (locale: Locale) =>
  remember(
    serializeDataToCacheKey([CacheTag.bookinghub, 'getCabinPresents', locale]),
    () => getCabinGifts(locale),
    {
      tags: [CacheTag.pcl],
      ttl: 600,
      shouldCache: e => e.success,
    },
  );
